<template>
    <div class="app-notifications">
        <div v-for="msg in messages" :class="msg.type">
            <span class="close" @click="dismiss(msg)">X</span>
            {{ msg.message }}
        </div>
    </div>
</template>
<script>
export default {
  name: 'app-notifications',
  methods: {
    dismiss (msg) {
      this.$notify.remove(msg.id);
    },
  },
  computed: {
    messages () {
      return this.$messages
    },
  },
}
</script>
